import React, { useEffect, useState } from "react";
import "./NewApiReports.scss";
import DynamicForm from "../../../component/common/DynamicForm/dynamicForm";
import SystemXLoader from "../../../component/common/Loader/SystemXLoader";
import apiCall from "../../../utils/apiFunction/apiCall";
import moment from "moment";
import { errorMessages } from "../../../constants/Common/errorConstants";
import { toast } from "react-toastify";
import {
  apiConstants,
  errMessage,
  toastIds,
} from "../../../constants/Common/apiConstants";
import {
  commonVariables,
  dateFormats,
} from "../../../constants/Common/commonConstants";
import CustomTable from "../../../component/customtable/CustomTable";
import ScrollingText from "./ScrollingText";
import { chain, difference } from "lodash";

const NewApiReports = () => {
  const [formValues, setFormValues] = useState([
    {
      type: "textbox",
      value: '',
      label: "Contract no.",
      placeholder: "Contract no.",
      required: true,
      expandInput: true,
      width: 6,
    },
    {
      type: "dropdown",
      value: '',
      label: "Company name",
      placeholder: "Select company",
      required: true,
      width: 6,
      options: [
        { label: "Tata Capital Ltd", value: "7000" },
        { label: "Tata Capital Housing Finance Ltd", value: "9000" },
      ],
    },
  ]);
  const [tableShowData, setTableShowData] = useState([
    { id: 1, ContractNo: "TCFTW0277000012157260", utr: "UTR123", status: "Pending" },
    { id: 2, ContractNo: "TCFTW0837000012159119", utr: "UTR124", status: "Completed" },
    { id: 3, ContractNo: "TCFTW0537000012159742", utr: "UTR125", status: "Failed" },
  ]);
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [formData, setFormData] = useState();
  // const [checkedData, setCheckedData] = useState([]);

  const onSubmit = (value, data) => {
    console.log(value, data);
  };

  const changePage = (value) => {
    setPageNumber(value);
  };

  // const onDownload = () => {
  //   // setLoading(true);
  //   // console.log(checkedData)
  //   // apiCall
  //   //   .post(apiConstants?.downloadDisbursementReports, checkedData)
  //   //   .then((res) => {
  //   //     if (res?.data?.status === 200) {
  //   //       if (res?.data?.response) {
  //   //         const link = document.createElement("a");
  //   //         link.href = res?.data?.response;
  //   //         link.click();
  //   //         toast.success(commonVariables?.FileDownloadSuccess, {
  //   //           toastId: toastIds?.FileDownloadSucess,
  //   //         });
  //   //       } else {
  //   //         toast.error(res?.data?.message || errorMessages?.SOMETHING_WRONG, {
  //   //           toastId: toastIds?.DataError,
  //   //         });
  //   //       }
  //   //     } else {
  //   //       toast.error(res?.data?.message || errorMessages?.SOMETHING_WRONG, {
  //   //         toastId: toastIds?.DataError,
  //   //       });
  //   //     }
  //   //   })
  //   //   .catch((er) => {
  //   //     let resp = er?.message || "";
  //   //     toast.error(resp || errorMessages?.SOMETHING_WRONG, {
  //   //       toastId: toastIds?.SomethingWentWrong,
  //   //     });
  //   //   })
  //   //   .finally(() => {
  //   //     setLoading(false);
  //   //   });
  // };

  // const handleCheckAll = (checkAll) => {
  //   if (checkAll) {
  //     setCheckedData(
  //       chain(tableShowData)
  //         .map((e) => (e.disabled ? undefined : e))
  //         .filter()
  //         .value()
  //     );
  //   } else {
  //     setCheckedData([]);
  //   }
  // };

  // const handleCheckboxChange = (row) => {
  //   setCheckedData((prevCheckedData) => {
  //     if (prevCheckedData.some(item => item.id === row.id)) {
  //       return prevCheckedData.filter(item => item.id !== row.id);
  //     } else {
  //       return [...prevCheckedData, row];
  //     }
  //   });
  // };

  // const checkboxFormatter = (row) => (
  //   <div className="checkBoxForm">
  //     <input
  //       className="checkboxTablerow"
  //       type="checkbox"
  //       disabled={row.disabled}
  //       onChange={() => handleCheckboxChange(row)}
  //       checked={checkedData.some(item => item.id === row.id)}
  //       id={`checkbox-${row.id}`}
  //     />
  //   </div>
  // );

  const Table = () => {
    return (
      <div className="mx-4">
        <CustomTable
          cols={[
            // {
            //   id: "checkbox",
            //   checkbox: true,
            //   allChecked: tableShowData.length
            //     ? difference(
            //         tableShowData.map((e) => e),
            //         checkedData
            //       ).length === 0
            //     : false,
            //   handleCheckboxAction: () =>
            //     handleCheckAll(
            //       difference(
            //         tableShowData.map((e) => e),
            //         checkedData
            //       ).length !== 0
            //     ),
            //   formatter: checkboxFormatter,
            // },
            {
              id: "id",
              title: "Sr No.",
            },
            {
              id: "ContractNo",
              title: "Contract no.",
            },
            {
              id: "utr",
              title: "UTR",
            },
            {
              id: "status",
              title: "Status",
            },
          ]}
          data={tableShowData}
          count={count}
          activePage={pageNumber}
          loading={loading}
          setPagination={(page) => changePage(page)}
        />
      </div>
    );
  };

  useEffect(() => {
    if(pageNumber) {
      onSubmit(pageNumber, formData);
    }
  }, [pageNumber]);

  return (
    <div>
      {loading && (
        <div className="loaderDiv">
          <SystemXLoader />
        </div>
      )}
      <p className="disbursementTable_disbursementTableTxt px-4 mt-4 pt-2">
        <b>Reports</b>
      </p>
      <div className="disbursementTable_inputContainer mx-4 p-4">
        <DynamicForm onSubmit={(data) => {setFormData(data); onSubmit(pageNumber, data);}} previewBtn formValues={formValues} />
      </div>
      <div className="mx-4 mt-2">
        <div>
          <ScrollingText />
        </div>
      </div>
      <Table />
      {/* {checkedData.length > 0 && (
        <div className="mx-4 mt-2">
          <button className="btn btn-primary" onClick={onDownload}>
            Download Selected ({checkedData.length})
          </button>
        </div>
      )} */}
    </div>
  );
};

export default NewApiReports;